






































import { Component, Mixins, Prop } from 'vue-property-decorator';
import DateMethods from '@/mixins/DateMethods.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';
import CorporationLinkData from '@/ts/CorporationLinkData';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class CorporationLinkList extends Mixins(DateMethods) {
    @Prop({default: {mode: ''}}) public form: any;
    public tableEntity: string = 'CorporationLinkList';
    public corporationLinkDropdown: boolean = false;
    public corporationLinkDropdownIndex: number = -1;

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'title', label: this.$t('general.title', 'Title'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => {
                    return this.getLocalizedLinkProperty(row.languageVersions, 'title');
                },
            },
            { name: 'description', label: this.$t('general.description', 'Description'), align: 'left', sortable: true, required: false, filter: false,
             classes: 'hoc-links-table-column-xs',
                field: (row: any) => {
                    return this.getLocalizedLinkProperty(row.languageVersions, 'description');
                },
            },
            { name: 'url', label: this.$t('general.url', 'URL'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => {
                    return this.getLocalizedLinkProperty(row.languageVersions, 'url');
                },
            },
            { name: 'versions', label: this.$t('general.versions', 'Versions'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => {
                    return this.getLanguageVersions(row.languageVersions);
                },
            },
            { name: 'createdAt', label: this.$t('general.created-at', 'Created at'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => {
                    return this.getLocalizedLinkPropertyDate(row.languageVersions, 'created_at');
                },
            },
            { name: 'updatedAt', label: this.$t('general.updated-at', 'Updated at'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => {
                    return this.getLocalizedLinkPropertyDate(row.languageVersions, 'updated_at');
                },
            },
        ];
    }

    get languageId(): number {
        let corporationLinksData = this.$store.getters['CorporationLinks/getAdminCorporationLinks'];
        if (corporationLinksData) {
            // get an array of links' language versions
            corporationLinksData = corporationLinksData.map((linkData: CorporationLinkData) => linkData.languageVersions).flat(1);
            
            // current application language
            const currentLanguage = this.$store.getters['Localization/getCurrentLanguageObject'];
            if (currentLanguage && currentLanguage.hasOwnProperty('id') && corporationLinksData.some((linkData: any) => linkData.language_id === currentLanguage.id)) {
                return currentLanguage.id;
            }

            // corporation default language
            const corporation = this.$store.getters['Corporations/getCurrentCorporation'];
            if (corporation && corporation.default_language) {
               const corporationLanguage = this.$store.getters['Localization/getAllLanguages'].find((langauge: any) => langauge.key === corporation.default_language);
               if (corporationLanguage && corporationLanguage.hasOwnProperty('id') && corporationLinksData.some((linkData: any) => linkData.language_id === corporationLanguage.id)) {
                    return corporationLanguage.id;
               } 
            }
        }
        // fallback to English langauge Id
        return 1;
       
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'title',
                'description',
                'url',
                'updatedAt',
            ],
        };
    }

    get adminCorporationLinks(): CorporationLinkData[] {
        return this.$store.getters['CorporationLinks/getAdminCorporationLinks'];
    }

    get allLanguages() {
        return this.$store.getters['Localization/getAllLanguages'];
    }

    public getLocalizedLinkProperty(data: any, propertyName: string) {
         if (data) {
            const link = data.find((linkData: any) => linkData.language_id === this.languageId);
            if (link && link.hasOwnProperty(propertyName)) {
                return link[propertyName];
            } else {
                const defaultLink = data[0];
                if (defaultLink && defaultLink.hasOwnProperty(propertyName)) {
                    return defaultLink[propertyName];
                }
            }
        }
    }

    public getLocalizedLinkPropertyDate(data: any, propertyName: string) {
        if (data) {
            const link = data.find((linkData: any) => linkData.language_id === this.languageId);
            if (link && link.hasOwnProperty(propertyName)) {
                return this.getLocalDateTimeString(link[propertyName]);
            } else {
                const defaultLink = data[0];
                if (defaultLink && defaultLink.hasOwnProperty(propertyName)) {
                    return this.getLocalDateTimeString(defaultLink[propertyName]);
                }
            }
        }
    }

    public getLanguageVersions(data: any) {
        if (data) {
            const langauges = data.map((linkData: any) => {
                const lang = this.allLanguages.find((language: any) => language.id === linkData.language_id);
                if (lang && lang.hasOwnProperty('key')) {
                    return lang.key.toUpperCase();
                }
            });
            return langauges.join(', ');
        }
    }

    public editCorporationLinkFlyout(id: number) {
        this.$store.commit(Mutations.SET_CORPORATION_LINK_FORM_VISIBILITY, false);
        this.$set(this.form, 'mode', 'edit');
        this.$store.dispatch(Actions.FETCH_CURRENT_CORPORATION_LINK, id);
    }

    public deleteCorporationLink(id: number, key: string) {
        this.closeDropDown();
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'CorporationLinks/DELETE_CORPORATION_LINK',
            confirmActionData: { id },
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-link', 'Are you sure you want to delete this link?'),
            confirmInfoText: `${key}`,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public toggleCorporationLinkDropdown(index: number) {
        if (index === this.corporationLinkDropdownIndex) {
            this.closeDropDown();
        } else {
            this.corporationLinkDropdown = this.corporationLinkDropdownIndex !== -1 ? true : !this.corporationLinkDropdown;
            this.corporationLinkDropdownIndex = index;
        }
    }

    public closeDropDown() {
        this.corporationLinkDropdown = false;
        this.corporationLinkDropdownIndex = -1;
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }

    public created() {
        window.addEventListener('click', this.closeDropDown);
    }

}
